<template>
  <form @submit="submit" class="form-container-contact">
    <label for="profile_picture" class="profile-image-picker">
      <img :src="profilePlaceholder" id="profile-placeholder" />
      <input
        type="file"
        id="profile_picture"
        @change="onFileChange"
        accept="image/*"
      />
      <input type="file" />
    </label>
    <label for="email">Email</label>
    <input type="email" v-model="email" id="email" required />
    <label for="name">Name</label>
    <input type="text" v-model="name" id="name" />
    <label for="mobile_number">Mobile Number</label>
    <input type="tel" v-model="mobile_number" id="mobile_number" />
    <button type="submit" class="btn mx-0">
      <span v-if="!isloading">Save Profile</span>
      <span v-else>Loading...</span>
    </button>
    <p v-if="error != ''" class="text-danger">{{ error }}</p>
  </form>
</template>

<script>
export default {
  name: "account-form",
  props: ["user"],
  data() {
    return {
      email: "",
      name: "",
      mobile_number: "",
      error: "",
      profilePlaceholder: "",
      profileBase64: "",
      isloading: false,
    };
  },
  mounted() {
    if (this.user) {
      this.email = this.user.email;
      this.mobile_number = this.user.mobile_number;
      this.name = this.user.name;
      this.profilePlaceholder =
        this.user.profile_picture != ""
          ? this.user.profile_picture.url
          : "/imgs/profile_placeholder.png";
    }
  },
  methods: {
    async onFileChange(e) {
      const file = e.target.files[0];
      const vm = this;
      this.profilePlaceholder = URL.createObjectURL(file);
      this.profileBase64 = await this.toBase64(file);
      console.log(this.profileBase64);
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    submit(e) {
      e.preventDefault();
      this.isloading = true;
      this.$http
        .put("/api/v1/user/accounts", {
          account: {
            profile_picture: this.profileBase64 ? this.profileBase64 : this.profilePlaceholder,
            remove_profile_picture: this.profilePlaceholder == '/imgs/profile_placeholder.png' ? true : false,
            email: this.email,
            name: this.name,
            mobile_number: this.mobile_number,
          },
        })
        .then((res) => {
          this.$toast.success("Account updated successful", {
            position: "top-right",
          });
          window.location.reload();
          this.isloading = false;
        })
        .catch((e) => {
          this.isloading = false;
          this.error =
            "We're sorry, but something went wrong. Please try again later";
        });
    },
  },
};
</script>

<style scoped>
.profile-image-picker {
  display: block;
  height: 100px;
  width: 100px;
  margin: auto;
  position: relative;
  overflow: hidden;
  border-radius: 100%;
}

.profile-image-picker img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.form-container-contact input[type=file] {
  display: block;
  opacity: 0;
  height: 0;
  width: 0;
}
</style>